import { render } from "./UpdatesAvailableModal.vue?vue&type=template&id=0d94653c"
import script from "./UpdatesAvailableModal.vue?vue&type=script&lang=js"
export * from "./UpdatesAvailableModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__